export default "__VITE_ASSET__PZlNLCss__"